import React, { Component } from 'react';
import { connect } from 'react-redux';
import {Checkbox} from 'antd';
import { FormattedMessage} from 'react-intl';
import { fetchUserGroups } from '../actions/usergroups';
import SearchTable from './SearchTable'
import LoadingControl from './Loading';
import {compareStrings} from '../utils/utils'

class UserGroupsSelectTable extends Component {

    constructor(props) {
        super(props);

        if (this.props.group_id !== undefined)
        {
            // отмеченные принтеры в отчете переставляем в начало таблицы
            this.props.groups.sort((x, y) => { return x.id === this.props.group_id ? -1 : y.id === this.props.group_id ? 1 : 0; });
        }

        this.state = {
            showGroups: this.props.group_id === undefined ? false : true,
            selectedRowKeys: this.props.group_id === undefined ? [] : [this.props.group_id],
          };

        this.layout = {
            bordered : true,
            showSizeChanger : false, 
            pagination : {pageSize: 10, showSizeChanger: false},
            size: "small",
            rowKey : record => record.id,
        };

        this.columns = [
            {
              title: <FormattedMessage id="DeviceMetersTable.name"/>,
              dataIndex: 'name',
              sorter: {
                compare: (a, b) => compareStrings(a.name, b.name),
              },
              search: true,
            },
        ];   
      }
      
    componentDidMount() {  
        if (this.props.groups === undefined || this.props.groups.length === 0)
        {
            this.props.fetchData();
        }
    }

    onAllUsers(e)
    {
        this.setState({showGroups: !e.target.checked});

        if (this.props.onSelectChange !== undefined && e.target.checked)
        {
            this.props.onSelectChange([undefined]);
        }
    }

    onSelectChange(selectedRowKeys) {
        if (this.props.onSelectChange !== undefined)
        {
            this.props.onSelectChange(selectedRowKeys);
        }
    }

    render() {
        if(this.props.hasError != null)
        {
          return (
            <div><h3>{this.props.hasError.message}</h3></div>
          );
        }
        else if (this.props.isLoading)
        {
          return (
            <div><LoadingControl size="small"/></div>
          );
        }
        else
        {
            return (
                <div>
                    <Checkbox checked={!this.state.showGroups} onChange={(e) => this.onAllUsers(e)}><FormattedMessage id="AllUserGroups"/></Checkbox>
                    <br></br><br></br>
                    {this.state.showGroups && 
                                        <SearchTable
                                            layout = {this.layout}
                                            type = "radio"
                                            onSelectChange = {(selectedRowKeys) => this.onSelectChange(selectedRowKeys)}
                                            initialSelection={this.state.selectedRowKeys}
                                            columns={this.columns} 
                                            dataSource={this.props.groups} />
                        }
                </div>
            );
        }
      }
}
const mapStateToProps = (state) => {
    return {
        groups: state.usergroups,
        hasError: state.usergroupsHasError,
        isLoading: state.usergroupsIsLoading
    };
  };

const mapDispatchToProps = (dispatch) => {
return {
    fetchData: () => dispatch(fetchUserGroups()),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(UserGroupsSelectTable);